import React, { useState, useEffect } from 'react';
import { api, Badge, Pagination, paginate, SearchBox, searchFilter } from './shared';

const ClmLogsTab = ({ onError }) => {
  const [logs, setLogs] = useState(null);
  const [summary, setSummary] = useState(null);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  const fetch = async () => { setLoading(true); try { const r = await api('clm-logs'); setLogs(r.data.data); setSummary(r.data.summary); setPage(1); } catch(e) { onError(e.message); } finally { setLoading(false); } };
  useEffect(() => { fetch(); }, []); // eslint-disable-line

  const byType = logs ? (filter === 'all' ? logs : logs.filter(l => l.type === filter)) : [];
  const filtered = searchFilter(byType, search, ['type', 'message']);

  return (
    <div className="bts-admin__section">
      <div className="bts-admin__topbar">
        <div className="bts-admin__page-title">📋 CLM Log</div>
        <div className="bts-admin__actions">
          <button className="bts-admin__btn bts-admin__btn--dark" onClick={fetch} disabled={loading}>{loading ? 'โหลด...' : 'รีเฟรช'}</button>
        </div>
      </div>
      {loading && <p>กำลังโหลด...</p>}
      {summary && (<>
        <div className="bts-admin__cards">
          <div className={`bts-admin__card ${filter==='all'?'bts-admin__card--active':''}`} style={{ borderColor:'#333' }} onClick={() => { setFilter('all'); setPage(1); }}><div className="bts-admin__card-value" style={{ color:'#333' }}>{summary.total}</div><div className="bts-admin__card-label">ทั้งหมด</div></div>
          {summary.types.slice(0, 5).map((t, i) => {
            const colors = ['#459efc','#10C851','#FF8A00','#E24B4A','#999'];
            return (
              <div key={i} className={`bts-admin__card ${filter===t.type?'bts-admin__card--active':''}`} style={{ borderColor:colors[i] }} onClick={() => { setFilter(t.type); setPage(1); }}>
                <div className="bts-admin__card-value" style={{ color:colors[i] }}>{t.count}</div>
                <div className="bts-admin__card-label" style={{ fontSize:10 }}>{t.type.replace('bts_','')}</div>
              </div>
            );
          })}
        </div>
        <div className="bts-admin__case-box">
          <div className="bts-admin__case-title">สรุปประเภท Log</div>
          {summary.types.map((t, i) => (
            <div key={i} className="bts-admin__case-row" onClick={() => { setFilter(t.type); setPage(1); }}>
              <span>{t.type.includes('error')||t.type.includes('fail')?'🔴':t.type.includes('verified')||t.type.includes('success')?'✅':'📝'} {t.type}</span>
              <span className="bts-admin__case-count">{t.count}</span>
            </div>
          ))}
        </div>
      </>)}
      {logs && (<>
        <div className="bts-admin__filter-info"><span>แสดง {filtered.length} รายการ</span><SearchBox value={search} onChange={v => { setSearch(v); setPage(1); }} /></div>
        <div className="bts-admin__table-wrap">
          <table className="bts-admin__table">
            <thead><tr><th>วันที่</th><th>ประเภท</th><th>ข้อความ</th><th>รายละเอียด</th></tr></thead>
            <tbody>{paginate(filtered, page).map((l, i) => (
              <tr key={i} className={l.type.includes('error')||l.type.includes('fail')?'bts-admin__row--error':l.type.includes('verified')||l.type.includes('success')?'bts-admin__row--ok':''}>
                <td style={{ whiteSpace:'nowrap' }}>{new Date(l.created_at).toLocaleString('th-TH')}</td>
                <td><Badge color={l.type.includes('error')||l.type.includes('fail')?'red':l.type.includes('verified')||l.type.includes('success')?'green':'orange'}>{l.type.replace('bts_','')}</Badge></td>
                <td style={{ whiteSpace:'normal', maxWidth:300 }}>{l.message}</td>
                <td style={{ whiteSpace:'normal', maxWidth:300, fontSize:11 }}>{l.extra ? JSON.stringify(l.extra).substring(0, 150) : '-'}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
        <Pagination total={filtered.length} page={page} setPage={setPage} />
      </>)}
    </div>
  );
};

export default ClmLogsTab;
